import React, { useContext, useEffect } from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [isSuccess, clearCart]);

  return (
    <main className="successDiv">
      <div className="success-container">
        <div className="modal-content">
          <div className={`payment-result-icon ${isSuccess ? "success" : "cancel"}`}>
            <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
          </div>
          <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
          <p>{isSuccess ? "Thank you. Your payment was received and your order is being processed." : "Your payment was not completed. Your basket has been kept so you can try again."}</p>
          <Link className="payment-result-link" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaySuccess;
